import { isEmpty } from 'lodash';
import { transferLuggageFormToArray } from './luggage_form/helpers';

export const getPrimarySegments = (segments, journeys) => {
  const journeyIds = journeys.map((item) => item.segments).flat();

  return journeyIds.filter((id) => segments[id].is_primary_segment);
};

export const addVehicleBuffer = (vehicles, cmsVehicleTypes) =>
  vehicles.map((vehicle) => {
    const result = { ...vehicle };
    let buffer;
    const { cmsVehicleTypeId } = vehicle;
    if (cmsVehicleTypeId) {
      const cmsVehicleType = cmsVehicleTypes.find(
        (item) => item.id === Number(cmsVehicleTypeId)
      );
      buffer = cmsVehicleType?.buffer || 0;
    } else {
      // When we don't have cms type id but qt id, get all possible buffer and use the biggest one
      const qtVehicleTypeId = vehicle.vehicle_type_id;
      const buffers =
        cmsVehicleTypes
          ?.filter(
            (item) => item.qt_vehicle_type_id === qtVehicleTypeId && item.buffer
          )
          .map((item) => item.buffer) || [];
      buffer = Math.max(0, ...buffers);
    }

    result.buffer = Number(buffer);
    // Do not pass cmsVehicleTypeId to params
    delete result.cmsVehicleTypeId;
    return result;
  });

export const getFindParam = (
  values,
  allRoutes,
  sealinkConfigs,
  segmentId,
  isAutoSelect = false
) => {
  const formValues = values || {};
  const { journeyForm, passengerForm, luggageForm, vehicleForm } = formValues;
  const {
    journeys,
    journeyType,
    journeyDates,
    productTypeIds,
    productIdFields,
  } = journeyForm;
  const { vehicle_types: cmsVehicleTypes, segments } = sealinkConfigs;
  const segment = segments[segmentId];
  const journeyIndex = journeys[0].segments.includes(segmentId) ? 0 : 1;
  const [firstTravelDate] = journeyDates[journeyIndex].split('T');
  // If auto select ferry and has subroutes, don't send stop ids to api, backend will choose the service
  const segmentStop =
    !isEmpty(segment.subroutes) && isAutoSelect
      ? { departureRouteStop: {}, arrivalRouteStop: {} }
      : journeys[journeyIndex].segmentStops[segmentId];
  const fromRouteStopId = segmentStop.departureRouteStop.id;
  const toRouteStopId = segmentStop.arrivalRouteStop.id;
  let vehicleTypes = [];

  if (vehicleForm) {
    vehicleForm.vehicles.forEach((vehicle) => {
      vehicleTypes.push(
        // vehicle.id only available when editing a booking
        vehicle.id
          ? vehicle
          : {
              ...vehicle.finalDimensions,
              vehicle_type_id: vehicle.vehicleTypeId,
              cmsVehicleTypeId: vehicle.cmsVehicleTypeId,
              attachment_ids: vehicle.attachmentIds || [],
              make_code: vehicle.vehicleMake || null,
              family_code: vehicle.vehicleModel || null,
              body_style_code: vehicle.bodyStyle || null,
              year_code: vehicle.vehicleYear || null,
              variant_code: vehicle.vehicleModelVariant || null,
            }
      );

      // If vehicle with trailer
      if (vehicle.trailerRadio) {
        vehicleTypes.push({
          height: vehicle.trailerHeight,
          length: vehicle.trailerLength,
          details: vehicle.trailerDescription,
          cmsVehicleTypeId: vehicle.trailerRadio,
          vehicle_type_id: cmsVehicleTypes.find(
            (vehicleType) => vehicleType.id === Number(vehicle.trailerRadio)
          ).qt_vehicle_type_id,
        });
      }
    });
  }

  if (luggageForm) {
    vehicleTypes = vehicleTypes.concat(transferLuggageFormToArray(luggageForm));
  }

  const params = {
    product_type_id: allRoutes[segment.qt_route_id].product_type_id,
    route_id: segment.qt_route_id,
    from_route_stop_id: fromRouteStopId,
    to_route_stop_id: toRouteStopId,
    show: 'inventory_exists',
    get_availability:
      sealinkConfigs?.availabilityConfig?.showFerryAvailabilityServiceForm,
    forward: {
      first_travel_date: firstTravelDate,
      vehicle_types: addVehicleBuffer(vehicleTypes, cmsVehicleTypes),
      passenger_types: passengerForm.passengers,
      from_route_stop_id: fromRouteStopId,
      to_route_stop_id: toRouteStopId,
    },
    add_return: journeyType === 'return',
  };

  if (!segment.is_primary_segment) {
    params.forward.vehicle_types = [];
  }

  if (!isAutoSelect) {
    return params;
  }

  // For sending user ferry selections on the date picker component
  const productType = ['forward', 'return'][journeyIndex];
  const {
    productId,
    fromRouteStopId: fromRouteStopId_,
    toRouteStopId: toRouteStopId_,
  } = productTypeIds?.[productType]?.[firstTravelDate] || {};

  if (productId) {
    params.product_id_field = productIdFields[productType];
    params.product_id = productId;
    params.forward.from_route_stop_id = fromRouteStopId_;
    params.forward.to_route_stop_id = toRouteStopId_;
  }

  return params;
};

export const getFindParams = (
  values,
  allRoutes,
  sealinkConfigs,
  isAutoSelect
) => {
  const primarySegments = getPrimarySegments(
    sealinkConfigs.segments,
    values.journeyForm.journeys
  );

  return primarySegments.map((segmentId) =>
    getFindParam(values, allRoutes, sealinkConfigs, segmentId, isAutoSelect)
  );
};

export const getPreselectServiceFromBooking = ({ ferryReservations }) =>
  ferryReservations.reduce((acc, reservation, index) => {
    const key = index === 0 ? 'forward' : 'return';
    acc[key] = {
      [reservation.first_travel_date._value]: {
        tripId: reservation.trip_id,
        fromRouteStopId: reservation.from_route_stop_attributes?.id,
        toRouteStopId: reservation.to_route_stop_attributes?.id,
      },
    };
    return acc;
  }, {});
